// Identity of the CODE ACTUALLY RUNNING, which can disagree with the document's
// build meta: index.html is no-cache but the module graph comes from subresources
// the browser may serve stale, so an old build runs under a fresh document and
// every meta-based version check compares the fresh meta against itself.
//
// `import.meta.url` must be evaluated in main.tsx itself — the one module
// guaranteed to be in a bootstrap-imported chunk. Evaluated here it would report
// whatever shared chunk Rollup hoisted this into, and false-positive.

let executingEntryUrl: string | undefined;

/** Called once from main.tsx with its own `import.meta.url`. */
export function setExecutingEntryUrl(url: string): void {
    executingEntryUrl = url;
}

export function getExecutingEntryUrl(): string | undefined {
    return executingEntryUrl;
}
